import { useState } from "react";
import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Pagination from "components/ui/pagination/Pagination";

export default function FilteredDataTable({ data }) {
  const { t } = useTranslation();

  /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
  const recordsPerPage = 10;
  const [currentPageActive, setCurrentPageActive] = useState(1);
  const prePage = (currentPage, setCurrentPage) => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = (currentPage, setCurrentPage, npage) => {
    if (currentPage < npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateRecords = (data, currentPage, recordsPerPage) => {
    const firstIndex = (currentPage - 1) * recordsPerPage;
    const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
    return data?.slice(firstIndex, lastIndex);
  };

  // Calculate records for activeDiscounts
  const reportTransfersData = calculateRecords(
    data,
    currentPageActive,
    recordsPerPage
  );
  /* --------------------------------------------- End Pagination  -----------------------------------------------*/

  return (
    <>
      <>
        <Table>
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>{t("pages.reports.reports_tables.name")}</Th>
              <Th>{t("pages.reports.reports_tables.sku")}</Th>
              <Th>{t("pages.reports.reports_tables.barcode")}</Th>
              <Th>{t("pages.reports.reports_tables.storage_unit")}</Th>
              <Th>{t("pages.reports.reports_tables.from")}</Th>
              <Th>{t("pages.reports.reports_tables.to")}</Th>
              <Th>{t("pages.reports.reports_tables.quantity_sent")}</Th>
              <Th>{t("pages.reports.reports_tables.quantity_received")}</Th>
              <Th>{t("pages.reports.reports_tables.quantity_variance")}</Th>
              <Th>{t("pages.reports.reports_tables.cost_sent")}</Th>
              <Th>{t("pages.reports.reports_tables.cost_received")}</Th>
              <Th>{t("pages.reports.reports_tables.cost_variance")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {reportTransfersData?.map((item, index) => (
              <Tr key={item.TransfersItemsId}>
                <Td>{index + 1}</Td>
                <Td>{item?.InventoryItemNameEng}</Td>
                <Td>{item?.ItemRef}</Td>
                <Td>{item?.Barcode}</Td>
                <Td>{item?.StorageUnit}</Td>
                <Td>{item?.From}</Td>
                <Td>{item?.To}</Td>
                <Td>{item?.QuantitySent}</Td>
                <Td>{item?.QuantityRec}</Td>
                <Td>{item?.QuantityVar}</Td>
                <Td>{item?.CostSent}</Td>
                <Td>{item?.CostRec}</Td>
                <Td>{item?.CostVar}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          currentPage={currentPageActive}
          setCurrentPage={setCurrentPageActive}
          npage={Math.ceil(data?.length / recordsPerPage)}
          prePage={() => prePage(currentPageActive, setCurrentPageActive)}
          nextPage={() =>
            nextPage(
              currentPageActive,
              setCurrentPageActive,
              Math.ceil(data?.length / recordsPerPage)
            )
          }
        />
      </>
    </>
  );
}
